import { FlexBox, SelectionList, Spinner, Text } from '@dixa/lib-shared-habla';
import type { Language } from 'lib-shared-languages';
import { ampli } from 'lib-shared-tracking';
import { Dispatch, SetStateAction } from 'react';

import styles from './languageSelector.module.scss';

type LanguageSelectorProps = {
  languages: Language[];
  selectedLanguage: Language;
  setSelectedLanguage: Dispatch<SetStateAction<Language | undefined>>;
  isLoading: boolean;
};

export const LanguageSelector = ({
  languages,
  selectedLanguage,
  setSelectedLanguage,
  isLoading,
}: LanguageSelectorProps): JSX.Element | null => {
  return (
    <FlexBox
      borderWidth="0 1px 0 0"
      borderColor="neutral.200"
      height="320px"
      width="160px"
      flexDirection="column"
      justifyContent="center"
    >
      <SelectionList
        className={styles.list}
        onChange={(list) => {
          const language = list.selectedValues[0];
          setSelectedLanguage(language);
          ampli.quickReplyLanguageSelected({
            language: language.name,
          });
        }}
        selectedValues={selectedLanguage ? [selectedLanguage] : undefined}
      >
        {(isLoading && (
          <FlexBox display="flex" alignItems="center" justifyContent="center">
            <Spinner size={32} />
          </FlexBox>
        )) ||
          languages.map((language) => (
            <SelectionList.Item
              key={language.code}
              value={language}
              title={language.name}
              className={styles.listItem}
            >
              <Text.Paragraph>{language.name}</Text.Paragraph>
            </SelectionList.Item>
          ))}
      </SelectionList>
    </FlexBox>
  );
};
